/*
 * Keyboard Character (Figma 119:15079): 16×16, 4px padding-x, radius 4, --surface-page fill,
 * 1px --border-strong; text 12/16, weight 400, --text-weaker, tracking 0.12px (1%), centered.
 */
import { cx } from './cx'

export function Kbd({ children, className }: { children: string; className?: string }) {
    return (
        <kbd
            className={cx(
                'box-border flex size-[16px] shrink-0 flex-col items-center justify-center rounded-[4px] border border-solid',
                'border-[var(--border-strong)] bg-[var(--surface-page)] px-[4px]',
                'text-center text-[12px] leading-[16px] font-normal tracking-[0.12px] text-[var(--text-weaker)]',
                className,
            )}
        >
            {children}
        </kbd>
    )
}
